export const RANGE_MS = {
    "5D": 5 * 86400000,
    "1M": 30 * 86400000,
    "3M": 90 * 86400000,
    "1Y": 365 * 86400000,
};
/** Resolve a footer range key to a time window ending at `lastTs`. `All` = fit. */
export function resolveRangeWindow(key, lastTs, firstTs) {
    if (!Number.isFinite(lastTs) || lastTs <= 0)
        return { fit: true };
    if (key === "All")
        return { fit: true };
    if (key === "YTD") {
        const d = new Date(lastTs);
        return { from: new Date(d.getFullYear(), 0, 1).getTime(), to: lastTs };
    }
    const span = RANGE_MS[key];
    if (!Number.isFinite(span))
        return { fit: true };
    const from = Math.max(lastTs - span, Number.isFinite(firstTs) && firstTs > 0 ? firstTs : 0);
    return { from, to: lastTs };
}
